import React from "react";
import { FaQuoteLeft, FaStar } from "react-icons/fa";
import { useScrollReveal } from "../../hooks/useScrollReveal";
import "./Testimonials.css";

const testimonials = [
  {
    name: "Yves Kouadio",
    role: "Gerant, Restaurant La Belle Cote — Adjame",
    text: "NEXUS SOLUTIONS a cree notre site en 8 jours chrono. Depuis, on recoit des reservations en ligne directement. Avant, on perdait des clients qui ne trouvaient pas notre adresse sur WhatsApp.",
    stars: 5,
  },
  {
    name: "Aminata Diabate",
    role: "Fondatrice, Boutique Mode Aminata — Cocody",
    text: "J'avais peur que le digital soit trop cher pour moi. Ils m'ont propose une solution adaptee a mon budget. Ma boutique en ligne accepte Orange Money et Wave — mes clients adorent ca.",
    stars: 5,
  },
  {
    name: "Seydou Coulibaly",
    role: "Directeur, Agence de transport SC — Yopougon",
    text: "Notre application de reservation a ete livree en 5 semaines. Elle fonctionne parfaitement sur Android, qui est le telephone de 90% de nos clients. Serieux et reactifs.",
    stars: 5,
  },
];

export default function Testimonials() {
  useScrollReveal();

  return (
    <section className="testimonials">
      <h2 data-reveal="">Ce que disent nos clients</h2>
      <p className="testimonials-sub" data-reveal="" data-delay="100">
        Des entrepreneurs ivoiriens qui ont fait confiance a NEXUS SOLUTIONS.
      </p>
      <div className="testimonials-grid">
        {testimonials.map((t, i) => (
          <div
            className="testimonial-card"
            key={t.name}
            data-reveal=""
            data-delay={i * 120}
          >
            <FaQuoteLeft className="testimonial-quote" size={22} />
            <p className="testimonial-text">{t.text}</p>
            <div className="testimonial-stars">
              {Array.from({ length: t.stars }).map((_, j) => (
                <FaStar key={j} size={14} className="testimonial-star" />
              ))}
            </div>
            <div className="testimonial-author">
              <div className="testimonial-avatar">
                {t.name.charAt(0)}
              </div>
              <div>
                <div className="testimonial-name">{t.name}</div>
                <div className="testimonial-role">{t.role}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
